import React from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import './Layout.css';

function Layout({ children, onLoginClick }) {
  return (
    <div className="public-layout">
      <PublicHeader onLoginClick={onLoginClick} />
      <main className="public-main">{children}</main>
      <footer className="public-footer">
        <div className="footer-inner">
          <p className="footer-brand">FARMFLEET</p>
          <p className="footer-tagline">Agricultural Logistics Platform</p>
          <p className="footer-scope-note">
            Milestone 1 core: WhatsApp ordering and admin dispatch dashboard. This site shares
            information and contact options.
          </p>
          <p className="footer-contact">Contact: +237 6 51 41 27 72</p>
          <div className="footer-quick-links">
            <span className="footer-quick-links-title">Quick Links</span>
            <div className="footer-links">
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <Link to="/mission">Mission</Link>
              <Link to="/vision">Vision</Link>
              <Link to="/services">Services</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Layout;
